/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { Button } from '@scuf/common';
import ChartWidget from '../../../shared/Chart/ChartWidget';
import { graphEnergy } from '../../../shared/Utils/Utils';
import { ApiContext } from '../../../../context/ApiContext';
import {
  IAny,
  IConvertDataForUtilityTrendChart,
  IUtilityCostData
} from '../../IEnergyManagementProps';
import { actualWithColor } from '../UtilityLineGraphComponent/UtilityLineGraphComponent';
interface IUtilityCostComponentProps {
  data: IUtilityCostData;
}

export const UtilityGraphComponent = (props: IUtilityCostComponentProps) => {
  const [t, lng] = useTranslation();
  const d = descriptors.energyManagement;
  const { data } = props;

  const apiContext = useContext(ApiContext);
  const { onUtilityBillViewDetailsClick, hideHeader } = apiContext;

  const onViewDetailsClick = () => {
    if (onUtilityBillViewDetailsClick) {
      onUtilityBillViewDetailsClick();
    }
  };

  const { utilityCostCurrency, monthwiseAggregations } = data;

  const graphData = graphEnergy(
    (monthwiseAggregations as unknown) as IConvertDataForUtilityTrendChart[],
    undefined,
    lng
  );
  const { YearIndex, MonthIndex } = graphData;

  let { 0: first, [MonthIndex.length - 1]: last } = MonthIndex;
  let { 0: previousyear, [YearIndex.length - 1]: currentyear } = YearIndex;

  const actualColorUpdateIngraphData = actualWithColor(graphData);

  return (
    <div className="kpi-card-flex-container">
      <div className="kpi-card-monthwise-container">
        {previousyear != currentyear ? (
          <div className="kpi-card-monthwise-date-range energyGraph">
            {t(d.Utilitycost)} {first} {previousyear} - {last} {currentyear}
          </div>
        ) : (
          <div className="kpi-card-monthwise-date-range energyGraph">
            {t(d.Utilitycost)} {first} - {last} {currentyear}
          </div>
        )}
        <ChartWidget
          graphData={actualColorUpdateIngraphData as IAny}
          unit={utilityCostCurrency!}
          axisUnitType="currency"
          height="120px"
          legendBaseline={false}
          utilityGraphText={true}
          removePadding={true}
          hideHeader={hideHeader}
        />
        {hideHeader ? (
          ''
        ) : (
          <div className="kpi-card-view-details New-siteDashboard">
            <Button
              type="link"
              content={t(d.VIEWDETAILS)}
              className="view-details-button"
              onClick={() => onViewDetailsClick()}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default UtilityGraphComponent;
